const currentYear = new Date().getFullYear();

function ageToYearOfBirth(estimatedAge: number): number {
  return currentYear - estimatedAge;
}

export { ageToYearOfBirth };
